import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import Modal from "react-responsive-modal";
import TimePicker from "react-time-picker";
import AsyncSelect from "react-select/lib/Async";
import { NumberField } from "../../../../../../Utils/renderField/fieldsHookForms";
import { calcularDRCSolidos } from "../../../../../../Utils/LaboratorioDRC/CalculosDRCSolidos";
import { RenderNumberPercentage } from "../../../../../../Utils/renderField/renderReadField";
import Alerta from "../../../../../../Utils/Alerta/Alerta";

export const ModalDRC = ({
    opened,
    onClose,
    loadLaboratoristas,
    AgregarDatoDRC,
    datoDRCEditar,
    ActualizarDatoDRC,
    rangoDRC,
}) => {
    const {
        control,
        formState: { errors },
        getValues,
        trigger,
        reset,
        watch,
    } = useForm({
        defaultValues: {
            peso_muestra: datoDRCEditar ? datoDRCEditar.peso_muestra : "",
            peso_crepa: datoDRCEditar ? datoDRCEditar.peso_crepa : "",
            peso_humedo_1: datoDRCEditar ? datoDRCEditar.peso_humedo_1 : "",
            peso_humedo_2: datoDRCEditar ? datoDRCEditar.peso_humedo_2 : "",
            peso_humedo_3: datoDRCEditar ? datoDRCEditar.peso_humedo_3 : "",
            peso_seco_1: datoDRCEditar ? datoDRCEditar.peso_seco_1 : "",
            peso_seco_2: datoDRCEditar ? datoDRCEditar.peso_seco_2 : "",
            peso_seco_3: datoDRCEditar ? datoDRCEditar.peso_seco_3 : "",
            hora_ingreso: datoDRCEditar ? datoDRCEditar.hora_ingreso : "",
            hora_salida: datoDRCEditar ? datoDRCEditar.hora_salida : "",
            laboratorista: datoDRCEditar ? datoDRCEditar.laboratorista : null,
        },
    });

    const [modoEdicion, setModoEdicion] = React.useState(!!datoDRCEditar);

    useEffect(() => {
        if (datoDRCEditar) {
            reset({
                peso_muestra: datoDRCEditar.peso_muestra,
                peso_crepa: datoDRCEditar.peso_crepa,
                peso_humedo_1: datoDRCEditar.peso_humedo_1,
                peso_humedo_2: datoDRCEditar.peso_humedo_2,
                peso_humedo_3: datoDRCEditar.peso_humedo_3,
                peso_seco_1: datoDRCEditar.peso_seco_1,
                peso_seco_2: datoDRCEditar.peso_seco_2,
                peso_seco_3: datoDRCEditar.peso_seco_3,
                hora_ingreso: datoDRCEditar.hora_ingreso,
                hora_salida: datoDRCEditar.hora_salida,
                laboratorista: datoDRCEditar.laboratorista,
            });
            setModoEdicion(true);
        } else {
            reset({
                peso_muestra: "",
                peso_crepa: "",
                peso_humedo_1: "",
                peso_humedo_2: "",
                peso_humedo_3: "",
                peso_seco_1: "",
                peso_seco_2: "",
                peso_seco_3: "",
                hora_ingreso: "",
                hora_salida: "",
                laboratorista: null,
            });
            setModoEdicion(false);
        }
    }, [datoDRCEditar, reset]);

    const SubmitForm = async () => {
        const isValid = await trigger();
        if (!isValid) return;

        const formValues = getValues();
        const itemValues = { ...formValues, ...drcValues, drc_promedio_total };

        if (modoEdicion) {
            // Actualizar
            ActualizarDatoDRC({ ...itemValues, id: datoDRCEditar.id });
        } else {
            // Agregar nuevo
            AgregarDatoDRC(itemValues);
        }

        // clear form and close modal
        reset();

        onClose();
    };

    const drcValues = calcularDRCSolidos(watch());

    const { drc_promedio_1, drc_promedio_2, drc_promedio_3 } = drcValues;

    const drc_promedio_total =
        (drc_promedio_1 + drc_promedio_2 + drc_promedio_3) / 3;

    const [mostrarAlerta, setMostrarAlerta] = React.useState(false);

    useEffect(() => {
        if(!drc_promedio_1 || !drc_promedio_2 || !drc_promedio_3) {
            setMostrarAlerta(false);
            return;
        }
        
        const array_drc_promedios = [
            drc_promedio_1,
            drc_promedio_2,
            drc_promedio_3,
        ];

        const RANGO_DRC = rangoDRC;

        let min = Math.min(...array_drc_promedios);
        let max = Math.max(...array_drc_promedios);

        min = min * 100;
        max = max * 100;

        if (max - min > RANGO_DRC) {
            setMostrarAlerta(true);
        } else {
            setMostrarAlerta(false);
        }
    }, [drc_promedio_1, drc_promedio_2, drc_promedio_3]);

    return (
        <Modal
            open={opened}
            onClose={onClose}
            closeOnEsc={false}
            closeOnOverlayClick={false}
        >
            <div>
                <h3>DATOS DRC</h3>
                {!!mostrarAlerta && (
                    <div className="form-group grid-container d-flex align-items-center flex-column">
                        <Alerta
                            texto="Los valores de DRC se excedieron por mas de 3 puntos"
                            danger={true}
                        />
                    </div>
                )}
                <div className="formulario-fields-row">
                    {/* PESO MUESTRA */}
                    <div className="formulario-field">
                        <label>Peso muestra (P1)</label>
                        <NumberField
                            control={control}
                            name="peso_muestra"
                            errors={errors}
                            allowNegative={false}
                            suffix=" Kg"
                            rules={{
                                required: "Este campo es obligatorio",
                                min: {
                                    value: 1,
                                    message: "Debe ser al menos 1",
                                },
                            }}
                        />
                    </div>

                    {/* PESO CREPA */}
                    <div className="formulario-field">
                        <label>Peso crepa (P2)</label>
                        <NumberField
                            control={control}
                            name="peso_crepa"
                            errors={errors}
                            allowNegative={false}
                            suffix=" Kg"
                            rules={{
                                required: "Este campo es obligatorio",
                                min: {
                                    value: 1,
                                    message: "Debe ser al menos 1",
                                },
                            }}
                        />
                    </div>
                </div>

                <div className="formulario-fields-row">
                    {/* HUMEDO 1 */}
                    <div className="formulario-field">
                        <label>Peso húmedo 1</label>
                        <NumberField
                            control={control}
                            name="peso_humedo_1"
                            errors={errors}
                            allowNegative={false}
                            suffix=" Kg"
                            rules={{
                                required: "Este campo es obligatorio",
                                min: {
                                    value: 1,
                                    message: "Debe ser al menos 1",
                                },
                            }}
                            decimalScale={3}
                        />
                    </div>

                    {/* HUMEDO 2 */}
                    <div className="formulario-field">
                        <label>Peso húmedo 2</label>
                        <NumberField
                            control={control}
                            name="peso_humedo_2"
                            errors={errors}
                            allowNegative={false}
                            suffix=" Kg"
                            rules={{
                                required: "Este campo es obligatorio",
                                min: {
                                    value: 1,
                                    message: "Debe ser al menos 1",
                                },
                            }}
                            decimalScale={3}
                        />
                    </div>

                    {/* HUMEDO 3 */}
                    <div className="formulario-field">
                        <label>Peso húmedo 3</label>
                        <NumberField
                            control={control}
                            name="peso_humedo_3"
                            errors={errors}
                            allowNegative={false}
                            suffix=" Kg"
                            rules={{
                                required: "Este campo es obligatorio",
                                min: {
                                    value: 1,
                                    message: "Debe ser al menos 1",
                                },
                            }}
                            decimalScale={3}
                        />
                    </div>
                </div>

                <div className="formulario-fields-row">
                    {/* SECO 1 */}
                    <div className="formulario-field">
                        <label>Peso seco 1</label>
                        <NumberField
                            control={control}
                            name="peso_seco_1"
                            errors={errors}
                            allowNegative={false}
                            suffix=" Kg"
                            rules={{
                                required: "Este campo es obligatorio",
                                min: {
                                    value: 1,
                                    message: "Debe ser al menos 1",
                                },
                            }}
                            decimalScale={3}
                        />
                    </div>

                    {/* SECO 2 */}
                    <div className="formulario-field">
                        <label>Peso seco 2</label>
                        <NumberField
                            control={control}
                            name="peso_seco_2"
                            errors={errors}
                            allowNegative={false}
                            suffix=" Kg"
                            rules={{
                                required: "Este campo es obligatorio",
                                min: {
                                    value: 1,
                                    message: "Debe ser al menos 1",
                                },
                            }}
                            decimalScale={3}
                        />
                    </div>

                    {/* SECO 3 */}
                    <div className="formulario-field">
                        <label>Peso seco 3</label>
                        <NumberField
                            control={control}
                            name="peso_seco_3"
                            errors={errors}
                            allowNegative={false}
                            suffix=" Kg"
                            rules={{
                                required: "Este campo es obligatorio",
                                min: {
                                    value: 1,
                                    message: "Debe ser al menos 1",
                                },
                            }}
                            decimalScale={3}
                        />
                    </div>
                </div>

                <div className="formulario-fields-row">
                    {/* HORA INGRESO */}
                    <div className="formulario-field">
                        <label>Hora ingreso</label>
                        <Controller
                            name="hora_ingreso"
                            control={control}
                            rules={{
                                required: "Este campo es obligatorio",
                            }}
                            render={({ field }) => (
                                <TimePicker
                                    maxDetail="minute"
                                    locale="en-US"
                                    disableClock={true}
                                    clearIcon={null}
                                    {...field}
                                    onChange={(value) => {
                                        field.onChange(value);
                                    }}
                                    disabled={false}
                                />
                            )}
                        />
                        {errors.hora_ingreso && (
                            <small className="text-danger">
                                {errors.hora_ingreso.message}
                            </small>
                        )}
                    </div>

                    {/* HORA SALIDA */}
                    <div className="formulario-field">
                        <label>Hora salida</label>
                        <Controller
                            name="hora_salida"
                            control={control}
                            rules={{
                                required: "Este campo es obligatorio",
                            }}
                            render={({ field }) => (
                                <TimePicker
                                    maxDetail="minute"
                                    locale="en-US"
                                    disableClock={true}
                                    clearIcon={null}
                                    {...field}
                                    onChange={(value) => {
                                        field.onChange(value);
                                    }}
                                    disabled={false}
                                />
                            )}
                        />
                        {errors.hora_salida && (
                            <small className="text-danger">
                                {errors.hora_salida.message}
                            </small>
                        )}
                    </div>

                    {/* LABORATORISTA */}
                    <div className="formulario-field">
                        <label>Laboratorista</label>
                        <Controller
                            name="laboratorista"
                            control={control}
                            rules={{
                                required: "Debe seleccionar un laboratorista",
                            }}
                            render={({ field }) => (
                                <AsyncSelect
                                    {...field}
                                    className="react-select-container"
                                    isSearchable
                                    isClearable
                                    cacheOptions
                                    defaultOptions
                                    loadOptions={loadLaboratoristas}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.nombre}
                                    onChange={(selected) => {
                                        field.onChange(selected);
                                    }}
                                />
                            )}
                        />
                        {errors.laboratorista && (
                            <small className="text-danger">
                                {errors.laboratorista.message}
                            </small>
                        )}
                    </div>
                </div>

                {/* READ ONLY FIELDS FOR AVG DRC */}
                <div className="card-empty px-4">
                    <div className="formulario-fields-row">
                        <div className="formulario-field">
                            <label>DRC Promedio 1</label>
                            <RenderNumberPercentage
                                value={drc_promedio_1}
                                className="form-control analisis-drc-prod__datos-drc-disabled-field"
                                decimals={3}
                            />
                        </div>

                        <div className="formulario-field">
                            <label>DRC Promedio 2</label>
                            <RenderNumberPercentage
                                value={drc_promedio_2}
                                className="form-control analisis-drc-prod__datos-drc-disabled-field"
                                decimals={3}
                            />
                        </div>

                        <div className="formulario-field">
                            <label>DRC Promedio 3</label>
                            <RenderNumberPercentage
                                value={drc_promedio_3}
                                className="form-control analisis-drc-prod__datos-drc-disabled-field"
                                decimals={3}
                            />
                        </div>
                    </div>
                </div>

                <div
                    className=" d-flex justify-content-center mt-4"
                    style={{ gap: "2rem" }}
                >
                    <button className="btn btn-outline-dark" onClick={onClose}>
                        Cancelar
                    </button>

                    <button
                        onClick={SubmitForm}
                        className="btn btn-primary"
                        disabled={mostrarAlerta}
                    >
                        Guardar
                    </button>
                </div>
            </div>
        </Modal>
    );
};
